import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './Translation.service';

/**
 * translate pipe
 *
 * Import using the TranslationsModule
 *
 * Usage in the template file:
 * {{ 'my.key' | translate }}
 *
 * Usage in the template file with an optional language code:
 * {{ 'my.key' | translate: 'enUS' }}
 */
@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {
    constructor(private TR: TranslationService) {}

    /**
     * Translate the key value with an optionally specified
     * language code.
     *
     * @param key The key to translate
     * @param languageCode Language code to enforce for the translation
     *
     * @returns Translated string
     */
    transform(key: string, languageCode?: string): string {
        const translatedValue = this.TR.key(key, languageCode);
        return translatedValue;
    }
}
